import * as Vue from "vue";
import * as mutations from "../../mutation-types"
import {processProjectService} from "./../project-services/actions"
import {processProject} from './../projects/actions'
import router from './../../../router'

export const processProposal = (store, item) => {
    if (item.contact) {
        store.dispatch('processContact', item.contact)
        item.contact_name = item.contact.full_name
        delete item.contact
    }

    if (item.lead_contact && item.lead_contact !== undefined) {
        store.dispatch('processContact', item.lead_contact)
        delete item.lead_contact
    }

    if (item.files) {
        _.each(item.files, file => store.dispatch('processFile', file))
        delete item.files
    }

    if (item.notes) {
        _.each(item.notes, note => store.dispatch('processNote', note))
        delete item.notes
    }

    if (item.project_services) {
        store.rootState.projectServices.items = []
        let i = 1
        _.each(item.project_services, itemservice => {
            itemservice.source_id = item.id
            itemservice.id = item.id ? itemservice.id : `s${i}`
            store.dispatch('processEditingProjectService', itemservice)
            i++
        })
        // delete item.project_services
    }

    if (item.project) {
        store.dispatch('processProject', item.project)
        delete item.project
    }

    if (item.contact_signer && item.contact_signer !== undefined) {
        store.dispatch('processContact', item.contact_signer)
        delete item.contact_signer
    }

    if (item.user_signer && item.user_signer !== undefined) {
        store.dispatch('processUser', item.user_signer)
        delete item.user_signer
    }

    store.commit(mutations.ADD_OR_UPDATE_PROPOSAL, item)
}

export const fetchProposals = (store, params) => {
    return axios.get(`/api/proposals`, { params })
        .then(res => {
            _.each(res.data.data, item => processProposal(store, item))
            store.commit(mutations.SET_PROPOSALS_TOTAL, res.data.total)
            return res
        })
}

export const fetchProposalById = (store, id) => {
    return axios.get(`/api/proposals/${id}`)
        .then(res => {
            processProposal(store, res.data.data)
            return res
        })
}

export const cloneProposalById = (store, id) => {
    return axios.get(`/api/proposals/${id}`)
        .then(res => {
            res.data.data.id = null
            res.data.data.number = null
            res.data.data.status= 26
            res.data.data.notable = false
            res.data.data.project_name += ' (CLONED)'
            res.data.data.project = null
            res.data.data.project_id = null

            processProposal(store, res.data.data)
            return res
        })
}

export const createProposal = (store, item) => {
    return axios.post(`/api/proposals`, item)
        .then(res => {
            processProposal(store, res.data.data)
            return res
        })
}

export const updateProposal = (store, item) => {
    return axios.patch(`/api/proposals/${item.id}`, item)
        .then(res => {
            processProposal(store, res.data.data)
            return res
        })
}

export const createOrUpdateProposal = (store, item) => {
    let project_services = store.getters.projectServicesBySource({
        source_id: item.id ? item.id : null,
        source_type: 'proposal'
    })

    project_services = _.map(project_services, (service, i) => {
        service.position = i
        return service
    })

    let payload = _.clone(item)
    payload.project_services = project_services

    return item.id ?
        updateProposal(store, payload) :
        createProposal(store, payload)
}

export const convertProposal = (store, item) => {
    return axios.patch(`/api/proposals/${item.id}/convert`)
        .then(res => {
            let project = res.data.data
            processProposal(store, res.data.data)
            router.push(`/projects/${res.data.data.id}/edit`)

            return res
        })
}

export const removeProposal = (store, item) => {
    return axios.delete(`/api/proposals/${item.id}`)
        .then(res => {
            store.commit(mutations.REMOVE_PROPOSAL, item)
            return res
        })
}

export const sendProposalEmail = (store, emailData) => {
    return axios.post(`/api/proposals/${emailData.entityIdProperty}/email`, emailData)
}

export const updateProposalRemindBy = (store, item) => {
    return axios.patch(`/api/proposals/${item.id}/postpone`, item)
        .then(res => {
            processProposal(store, res.data.data)
            return res
        })
}